import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
// import learnIcons from '../icons/learnIcons';
import ProgressIcon from '../ProgressIcon';
import './NavigationDropdownItem.css';

/* const getItemSubtitle = props => {
  let itemTitle;

  if (props.itemType === 'module') {
    itemTitle = `chapter ${props.module.acf.chapter_number}`;
  } else if (props.itemType === 'lesson') {
    itemTitle = `lesson ${props.module.acf.lesson_number}`;
  } else if (props.itemType === 'topic') {
    itemTitle = `topic ${props.module.acf.topic_number}`;
  }

  return itemTitle;
}; */

function NavigationItem(props) {
  const {
    module: {
      acf: {
        illustration_icon,
        chapter_number,
        lesson_number,
        topic_number,
        step_number,
        title,
        subtitle
      },
      post_title,
      colorScheme,
      completed,
      completion
    },
    chapterIntroPage,
    progress,
    itemType,
    isParentContent,
    displayProgressIcon
  } = props;

  let itemSlug;
  const defaultTopic = '01';

  let isChapterIntroPage = false;

  if (itemType === 'module') {
    itemSlug = `/learn/chapter/${chapter_number}`;
  } else if (itemType === 'lesson' || itemType === 'lesson-topics-nav') {
    itemSlug = `/learn/chapter/${chapter_number}/lessons/lesson/${lesson_number}/part/0`;
  } else if (itemType === 'topic') {
    itemSlug = `/learn/chapter/${chapter_number}/lessons/lesson/${lesson_number}/part/${parseInt(
      topic_number,
      10
    ) - 1}`;
  } else if (itemType === 'discharge') {
    itemSlug = `/discharge/${step_number}/lessons/${topic_number ||
      defaultTopic}/part/0`;
  } else if (itemType === 'discharge-topics') {
    itemSlug = `/discharge/${step_number}/lessons/01/part/${
      topic_number ? topic_number - 1 : '0'
    }`;
  } else if (itemType === 'chapter-intro-page') {
    isChapterIntroPage = true;
    itemSlug = `/learn/chapter/${chapter_number}/pages/${chapterIntroPage.post_name}`;
  }

  return (
    <Fragment>
      <NavLink
        className={classNames('dropdown-navigation-item', {
          'dropdown-navigation-item-chapter-intro-topic': isChapterIntroPage,
          completed
        })}
        to={itemSlug}
        activeClassName={isParentContent ? '' : 'active'}
      >
        {illustration_icon && displayProgressIcon && (
          <ProgressIcon
            colorScheme={colorScheme}
            percentage={progress || completion}
            imgSrc={illustration_icon}
          />
        )}
        {!isChapterIntroPage && (
          <div
            className={
              isParentContent
                ? 'dropdown-navigation-item__container__parent-content'
                : 'dropdown-navigation-item__container'
            }
          >
            {(itemType === 'topic' || itemType === 'discharge-topics') && (
              <span className="dropdown-navigation-item__progress-indicator" />
            )}
            <div
              className={
                isParentContent
                  ? 'dropdown-navigation-item__title-parent-content'
                  : 'dropdown-navigation-item__title'
              }
            >
              {title || post_title}
            </div>
            {itemType !== 'topic' && itemType !== 'discharge-topics' && (
              <div className="dropdown-navigation-item__chapter-number">
                {subtitle}
              </div>
            )}
          </div>
        )}
        {isChapterIntroPage && (
          <div className="dropdown-navigation-item__container">
            <div className="dropdown-navigation-item__title-chapter-intro-page">
              {chapterIntroPage.title || chapterIntroPage.post_title}
            </div>
          </div>
        )}
      </NavLink>
    </Fragment>
  );
}

export default React.memo(NavigationItem);



// WEBPACK FOOTER //
// ./src/components/NavigationDropdown/NavigationItem.js